// @ts-nocheck
import React, { useState } from "react";
import "../styles/UserActionsMenu.css";
import ReportUserModal from "./ReportUserModal";
import { blockUser } from "../api/moderation";
import { getUser } from "../auth/auth";
import { useToast } from "./ToastProvider";

export default function UserActionsMenu({ targetUserId, targetUserName }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const { showToast, confirm: confirmToast } = useToast();

  const handleBlock = async () => {
    const confirmed = await confirmToast({
      title: `Block ${targetUserName}?`,
      message: "They won't be able to message or trade with you.",
      confirmLabel: "Block User",
      cancelLabel: "Cancel",
      tone: "warning",
    });
    if (!confirmed) {
      return;
    }

    try {
      const currentUser = getUser();
      await blockUser(currentUser.id, targetUserId);
      showToast(`${targetUserName} has been blocked successfully.`, "success");
      setShowMenu(false);
      // Optionally: refresh page or update UI
      window.location.reload();
    } catch (error) {
      showToast(error.message || "Failed to block user", "error");
    }
  };

  return (
    <>
      <div className="user-actions-container">
        <button
          className="user-actions-button"
          onClick={() => setShowMenu(!showMenu)}
        >
          ⋮
        </button>

        {showMenu && (
          <div className="user-actions-menu">
            <button
              className="action-item report"
              onClick={() => {
                setShowMenu(false);
                setShowReportModal(true);
              }}
            >
              🚩 Report User
            </button>
            <button className="action-item block" onClick={handleBlock}>
              🚫 Block User
            </button>
          </div>
        )}
      </div>

      {showReportModal && (
        <ReportUserModal
          targetUserId={targetUserId}
          targetUserName={targetUserName}
          onClose={() => setShowReportModal(false)}
        />
      )}

      {/* Close menu when clicking outside */}
      {showMenu && (
        <div className="menu-backdrop" onClick={() => setShowMenu(false)} />
      )}
    </>
  );
}
